<template>
	<div class="container">
		<img src="@/assets/about-us/about-us-top-bg.png" class="top-bg" alt="">
		<div class="g-flex g-row-center">
			<div class="total-width g-m-t-30">
				<div class="info-card ">
					<div class="g-p-30">
						<!--   logo/长图   -->
						<div class="g-flex g-col-top g-row-between">
							<!--  logo  -->
							<img src="@/assets/about-us/about-us-logo.png" class="logo-img" alt="">
							<!--  长图  -->
							<img src="@/assets/examples/02.jpg" class="large-img" alt="">
						</div>
						<!--  富文本  -->
						<div class="g-m-t-30" v-html="content"></div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import {
		getConfig
	} from '@/api/home.js'
	export default {
		name: "about-us",
		data() {
			return {
				// 关于我们数据
				content: ''
			}
		},
		mounted() {
			this.getConfigInfo('intro')
		},
		methods: {
			getConfigInfo(type) {
				getConfig({
					type: type
				}).then(data => {
					this.content = data.content
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info-card {
		background: #fff;
		border-radius: 10px;
	}

	.top-bg {
		width: 100%;
		height: 340px;
	}

	.logo-img {
		width: 265px;
		height: 300px;
	}

	.large-img {
		width: 846px;
		height: 300px;
	}
</style>
